import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewAppCategories from './viewRelatedAppCategories';
import tableComposeExperienceUrls from './tableComposeExperienceUrls';
import tableComposeExperienceLiveUrls from './tableComposeExperienceLiveUrls';
import viewRelatedSportRoomPackages from './viewRelatedSportRoomPackages';
import { IconSize, IconType } from '../components/atoms/icon/icon';
import viewRelatedSportRoomTeams from './viewRelatedSportRoomTeams';
import viewRelatedSportRoomTags from './viewRelatedSportRoomTags';
import { OPERATING_SYSTEMS } from '../utils/operatingSystemUtils';
import viewRelatedSportRoomSponsor from './viewRelatedSportRoomSponsor';


const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'General values',
  attributeName:'Content-general-values',
  fields: [
    {
      attributeName: 'id',
      helpText: 'Id of the video.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      placeholder: 'Video name...',
      hidden:true
    },
    {
      attributeName: 'name',
      helpText: 'Title of the video.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Video name...',
    },
    {
      attributeName: 'isLive',
      helpText: 'Specifies if the content is a live stream or VOD.',
      label: 'Is Live',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'composeExperienceObj',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Media URL',
      visibleWhen:{"field":"isLive","value":false},
      placeholder: 'Video Url...',
      mainField:"url",
      fromConfigTable: tableComposeExperienceUrls,
      popupSize:'xl',
      fieldsToUpdate:["duration","content_type","composeExperienceLink"]
    },
    {
      attributeName: 'composeExperienceObj',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Media URL Live',
      visibleWhen:{"field":"isLive","value":true},
      placeholder: 'Video Url...',
      mainField:"url",
      popupSize:'xl',
      fromConfigTable: tableComposeExperienceLiveUrls,
      fieldsToUpdate:["duration","content_type","composeExperienceLink","liveLink"]

    },
    {
      attributeName: 'content_type',
      label: 'Content Type',
      default: 'Single-View',
      type: FormInputTypes.SELECT,
      helpText: 'Choose one type of content.',
      options: [
        { name: '(Unknown)', value: '-1' },
        { name: 'Single view', value: 'Single-View' },
        { name: 'Multi view', value: 'Multi-View' },
        { name: 'Immersive', value: 'Immersive' },
        { name: 'Immersive + Multi-View', value: 'Immersive-Multi-View' },
      ],
      disabled:true,
      // visibleWhen:[{"field":"id",value:"not-null"}]
    },
    {
      attributeName: 'duration',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Duration',
      visibleWhen:{"field":"isLive","value":false},
      placeholder: 'Video duration...',
      helpText: 'Duration of the video in the format mm:ss.',
      disabled:true,
      // visibleWhen:[{"field":"id",value:"not-null"}]
    },
     {
      attributeName: 'eventDate',
      label: 'Event Date',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Date when this video was recorded. This value can also be edited inside the Compose Experience.',
      visibleWhen:{"field":"isLive","value":false},
      disabled: true,
      visibleWhen:[{"field":"id",value:"not-null"}]
    },
    {
      attributeName: 'composeExperienceLink',
      label:'Media Link',
      type: FormInputTypes.LINK,
      icon: IconType.ARROW_RIGHT,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to the corresponding media.',
      // visibleWhen:[{"field":"id",value:"not-null"}]
    },   
    {
      attributeName: 'liveLink',
      label:'Live Link',
      type: FormInputTypes.LINK,
      icon: IconType.VIDEO,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to the corresponding live event.',
      // visibleWhen:[{"field":"isLive","value":true},{"field":"id","value":"not-null"}],
      visibleWhen:[{"field":"isLive","value":true}],
    },   
 
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: 'enabled',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'allow_screen_recording',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Allow Screen Recording',
      label: 'Screen Recording Enabled',
      hidden:true,
      required: true,
      default: false,
      helpText: 'Enable Screen Recording.',
      errorText: '',
      visibleWhenCreate:false,
      visibleWhenEdit:true
    },
    {
      attributeName: 'allow_casting',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Allow Screen Casting',
      label: 'Screen Casting Enabled',
      hidden:true,
      required: true,
      default: false,
      helpText: 'Enable Screen Casting.',
      errorText: '',
      visibleWhenCreate:false,
      visibleWhenEdit:true
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video.',
      type: FormInputTypes.DATE_TIME,
      default: defaultActivationDate.getTime(),
      sendAlwaysAtCreate: true,
    },
    {
      attributeName: 'startEpoch',
      visibleWhen:{"field":"isLive","value":true},
      label: 'Starting Time',
      helpText: 'Date of the starting event countdown.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration Time',
      helpText: 'Date of the expiration event for this video.',
      type: FormInputTypes.DATE_TIME,
      default: defaultExpirationDate.getTime(),
      sendAlwaysAtCreate: true,
    },
    {
      attributeName: 'isLiveContinuous',
      visibleWhen:{"field":"isLive","value":true},
      label: 'Remove Progress Indicator',
      helpText: 'Selecting this field hides the current progress indicator from the player bar, making it invisible to the end user. This option should remain checked for 24/7 live streams.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isLiveChannel',
      visibleWhen:{"field":"isLive","value":true},
      label: 'Is Live Channel',
      helpText: 'Selecting this field we indicate the live event is a live channel to assign the corresponding tag.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
     {
      attributeName: 'liveStatus',
      label: 'Stream Status',
      helpText: 'Check the status of a live event (STOPPED, ONGOING, ENDED). To change this value please click on "Live Link" in the field above and change in in the "Live App Contents" page',
      default: 'stopped',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Offline', value: 'offline' },
        { name: 'Live Ongoing', value: 'ongoing' },
        { name: 'Live Ended', value: 'ended' },
      ],
      disabled:true,
        visibleWhen:{"field":"isLive","value":true},
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewAppCategories,
      default: [],
      helpText: 'Video categories joined.',
    },
    {
      attributeName: 'appTags',
      label: 'Tags',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomTags,
      default: [],
      helpText: 'Tags related.',
    },
    {
      attributeName: 'id',
      label: 'Tags Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      canEdit: true,
      canCreate: true,
      tagMode:'content',
      helpText: 'Tags preview.',
    }, 
     {
      attributeName: 'appPackages',
      label: 'V.T. Providers',
      type: FormInputTypes.RELATIONSHIPFILTER,
      // maxElements:1,
      onSelectUrl:'appContentSportRoomCheck',
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomPackages,
      default: [],
      helpText: 'This content can be blocked by a sku provider or a manual provider registered on SKU V.T. Providers or Manual V.T. Providers, select one or multiple providers to block it.',
    },
    {
     attributeName:"sep5",
     type:FormInputTypes.SEPARATOR,
     text:"Poster Logo Images",
     visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
   },
    {
      attributeName: 'posterLogo',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Poster Logo',
      helpText: 'Logo used in poster hierarchy resolution. Content logo has priority over Space and App logos.',
      placeholder: 'Poster logo...',
      hasSelect: false,
      allowedSizes: [
        { width: 128, height: 128 },
        { width: 192, height: 128 },
      ],
      fileType: ['image/*'],
    },
    {
      attributeName: 'hideSpacePosterLogo',
      helpText: 'Prevent fallback to the Space poster logo.',
      label: 'Hide Space Logo',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'hideAppPosterLogo',
      helpText: 'Prevent fallback to the App poster logo. If disabled, this value is controlled by the Space.',
      label: 'Hide App Logo',
      default: false,
      type: FormInputTypes.CHECKBOX,
      enabledWhen: {
        field: 'canEditHideAppPosterLogo',
        values: [true],
      },
    },
    {
      attributeName: 'hideAppPosterLogoInfo',
      label: 'Info',
      type: FormInputTypes.STATIC_TEXT,
      default: 'This option is disabled because the App logo is hidden at Space level.',
      visibleWhen: {
        field: 'spaceHideAppPosterLogo',
        value: true,
      },
    },
     {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR,
      text:"End of Poster Logo",
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },   
   
    {
      attributeName: 'year',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Year',
      placeholder: 'Year, season or any value you want to display as Tag Year...',
      helpText: 'Year or season of the video.',
    },
    {
      attributeName:"sep3a",
      type:FormInputTypes.SEPARATOR
    },  
    {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      default: 'v2',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
  
    {
      attributeName: 'type',
      label: 'Type',
      default: 'mono',
      type: FormInputTypes.SELECT,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen:[{"field":"geometry","notValue":"v2"}]

    },
    {
      attributeName: 'isAudioRecordingAllowed',
      helpText: 'Specifies if the content allow audio feedback.',
      label: 'Allow Audio feedback ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isSlowMotionAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Slow motion ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Timeshift ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName:"sepTeams",
      type:FormInputTypes.SEPARATOR,
      visibleWhen:{"field":"isLive","value":false}
    },
    {
      attributeName: 'appTeams',
      label: 'Teams',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomTeams,
      helpText: 'Teams involved in this content, first will be the home team.',
      disabledWhenNew:true,
      visibleWhen:{"field":"isLive","value":false}
    },
     {
      attributeName: 'sponsor',
      label: 'Sponsor',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedSportRoomSponsor,
      helpText: 'Sponsor',
    },
   
    {
      attributeName: 'graphicManagerRun',
      type: FormInputTypes.LINK,
      label: 'Graphic Manager',
      icon: IconType.VIDEO,
      secondaryValue:'graphicManagerName',
      target:"_self",
      helpText: 'Graphic manager linked to this content',
      width: '10rem',
      iconSize: IconSize.DOUBLE,
      textNoLink:"No Graphic manager defined."

    },
    // {
    //   attributeName: 'interactableGraphicURL',
    //   type: FormInputTypes.DOWNLOADABLE,
    //   label: 'Interactable Graphics Manifest',
    //   helpText: 'URL to the interactualbe graphic manifest for the video.',
    //   placeholder: 'Interactuable graphics manifest...',
    //   fileType: ['.json'],
    // },

    {
      attributeName: 'graphicsManifestURL',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Graphics Manifest',
      helpText: 'URL to the graphics manifest for the video. To learn more about graphics manifest, please refer to the “Graphics Manifest” documentation.',
      placeholder: 'Video graphics manifest...',
      fileType: ['.json'],
    },

    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR,
      text:"Oculus Quest Images",
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR,
      text:"Android XR Images",
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.androidXR.key},
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR,
      text:"Vision Pro Images",
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.visionOS.key},
    },

     {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},

    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},

    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Extended Info Panel Cover Image 1120x416',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 1120, height: 416 }
      ],
      helpText: 'URL to the poster image file that will be show in the description panel to the client App.',
      placeholder: 'Video description poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},

    },
    
    // Android XR Images
    {
      attributeName: 'heroPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Hero Banner - 848x306',
      allowedSizes: [
        { width: 848, height: 306 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.androidXR.key},

    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Video Poster - 294x170',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 294, height: 170 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.androidXR.key},
    },
  
     // Vision OS Images
    {
      attributeName: 'heroPoster',
      type: FormInputTypes.DOWNLOADABLE,
      allowedSizes: [
        { width: 848, height: 306 },
        { width: 1696, height: 612 }
      ],
      
      hasSelect:false,
      label: 'Hero Banner - 1696x612 or 848x306',
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.visionOS.key},

    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Video Poster - 294x170 or 588x340',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 294, height: 170 },
        { width: 588, height: 340 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.visionOS.key},
    },
     {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Video Poster - 480x256',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 480, height: 256 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'xxl',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XXL Grid Poster 1120x992',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 1120, height: 992 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'xlVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Vertical Grid Poster 544x992',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 544, height: 992 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'xlHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'XL Horizontal Grid Poster 1120x416',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 1120, height: 416 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'lVertical',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Vertical Grid Poster 544x704',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 544, height: 704 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'lHorizontal',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'L Horizontal Grid Poster 832x416',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 832, height: 416 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'm',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'M Grid Poster 544x416',
      errorResolution: 'Older Image Resolution',
      allowedSizes: [
        { width: 544, height: 416 }
      ],
      helpText: 'Any valid url to a content file to use inside the main module.',
      placeholder: 'Poster URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    // {
    //   attributeName: 'promoImage',
    //   type: FormInputTypes.DOWNLOADABLE,
    //   label: 'Promotional Image (1920x1080 or 2560x1440)',
    //   allowedSizes: [
    //     { width: 2560, height: 1440 },
    //     { width: 1920, height: 1080 }
    //   ],
    //   helpText: 'Promo Image with hi resolution (1920px x 1080px or 2560px x 1440px).',
    //   placeholder: 'Promo URL...',
    //   hasSelect:false,
    //   fileType: ['image/*'],
    //   visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    // },
    {
      attributeName: 'promoPortraitImageId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Promotional Image Portrait (1080 x 1440)',
      allowedSizes: [
        { width: 1080, height: 1440 },
      ],
      helpText: 'Promo Portrait Image with hi resolution (1080px x 1440px).',
      placeholder: 'Promo Portrait URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
    {
      attributeName: 'promoLandscapeImageId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Promotional Landscape Image (3840x2160)',
      allowedSizes: [
        { width: 3840, height: 2160 },
      ],
      helpText: 'Promo Landscape Image with hi resolution (3840px x 2160px).',
      placeholder: 'Promo Landscape URL...',
      hasSelect:false,
      fileType: ['image/*'],
      visibleWhen:{"field":"operatingSystem","value":OPERATING_SYSTEMS.oculusQuest.key},
    },
     {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR,
      text:"End of Image Block",
    },
    {
      attributeName: 'tags',
      helpText: 'List of Identifiers to the contene',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Custom Identifier',
      multiple:true,
      hidden:true,
      placeholder: 'Press enter to add an identifier...',
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },

  ],
};
